import type { MouseEvent } from 'react';
import { useContext, useCallback } from 'react';
import styles from './CommonBasicModal.module.scss';
import { WHITE_BOARD_SIZE_PRESET } from '~/components/common/modal/presets/whiteBoardSizePreset';
import type { WhiteBoardSizes } from '~/components/common/modal/presets/whiteBoardSizePreset';
import { ModalContext } from '~/context/ModalContext';
import { pxVw } from '~/styles/ts/functions';

interface Props {
  children: JSX.Element | JSX.Element[];
  size: WhiteBoardSizes;
  onClick?: (e: MouseEvent) => void | Promise<void>;
}

export const CommonBasicModal = ({ children, onClick, size }: Props) => {
  const { closeModal } = useContext(ModalContext);

  const close: (e: MouseEvent) => void | Promise<void> = useCallback(
    async (e) => {
      onClick && (await onClick(e));
      closeModal();
    },
    [closeModal, onClick],
  );

  return (
    <div className={styles.container}>
      <button className={styles.background} onClick={close} />
      <div
        className={styles.whiteboard}
        style={{
          width: pxVw.SP(WHITE_BOARD_SIZE_PRESET[size].width),
          height: pxVw.SP(WHITE_BOARD_SIZE_PRESET[size].height),
        }}
      >
        {children}
      </div>
    </div>
  );
};
